import React from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { AdminLayout } from "../Components/Layout";
import PrivateRoute from "./PrivateRoute";
import { useEffect } from "react";
import { useState } from "react";
import {
  ProductVariationsList,
  AddProductVariations,
  EditProductVariations,
} from "../Pages/ProductVariations";
import {
  AdminUserListing,
  AddAdminUser,
  EditAdminUser,
} from "../Pages/AdminUser";
import ProductsList from "../Pages/Products/components/ProductList";
import AddProduct from "../Pages/Products/components/AddProduct";
import EditProduct from "../Pages/Products/components/EditProduct";
import CategoryList from "../Pages/Category/components/CategoryList";
import AddCategory from "../Pages/Category/components/AddCategory";
import EditCategory from "../Pages/Category/components/EditCategory";
// import FlowList from '../Pages/Flow/components/FlowList';
// import AddFlow from '../Pages/Flow/components/AddFlow';
// import EditFlow from '../Pages/Flow/components/EditFlow';
import Dashboard from "../Pages/Dashboard";
import GuideList from "../Pages/GuideProduct/components/GuideList";
import AddGuide from "../Pages/GuideProduct/components/AddGuide";
import EditGuide from "../Pages/GuideProduct/components/EditGuide";
import ClientUserListing from "../Pages/ClientUser/components/ClientUserListing";
import WelfareList from "../Pages/Welfare/components/WelfareList";
import EditWelfare from "../Pages/Welfare/components/EditWelfare";
import {
  AddDiscover,
  DiscoverDetail,
  DiscoverListing,
  EditDiscover,
} from "../Pages/Discover";
import Setting from "../Pages/Setting";
import { ProductDetail } from "../Pages/Products";
import GuideDetail from "../Pages/GuideProduct/components/GuideDetail";
import EmojiList from "../Pages/Emoji/components/EmojiList";
import AddEmoji from "../Pages/Emoji/components/AddEmoji";
import EditEmoji from "../Pages/Emoji/components/EditEmoji";
import AppNotificationList from "../Pages/AppNotification/components/NotificationsList";
import AddAppNotifications from "../Pages/AppNotification/components/AddNotifications";
import EditAppNotifications from "../Pages/AppNotification/components/EditNotifications";
import SymptomList from "../Pages/Symptom/components/SymptomList";
import AddSymptom from "../Pages/Symptom/components/AddSymptom";
import EditSymptom from "../Pages/Symptom/components/EditSymptom";
import FirebaseNotificationList from "../Pages/FirebaseNotification/components/FirebasNotificationsList";
import AddFirebaseNotifications from "../Pages/FirebaseNotification/components/AddFirebaseNotifications";
import EditFirebaseNotifications from "../Pages/FirebaseNotification/components/EditFirebaseNotifications";
import AddWelfare from "../Pages/Welfare/components/AddWelfare";
import Logout from "../Components/Logout";
import WelfareDetail from "../Pages/Welfare/WelfareDetail";
import RoleList from "../Pages/Role/components/RoleList";
import AddEdit from "../Pages/Role/components/AddEdit";
import RoleDetail from "../Pages/Role/components/RoleDetail";
import { checkPermission } from "../Utils/permissionHelper";
import ClientUserDetail from "../Pages/ClientUser/components/ClientUserDetail";
import Subscription from "../Pages/Subscription";
import { Analytics } from "../Pages/Analytics";
import { Reports } from "../Pages/Reports";

// Permission-based route wrapper component
const PermissionRoute = ({ Component, requiredPermission, ...props }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (requiredPermission && !checkPermission(requiredPermission)) {
      navigate('/admin/dashboard');
    }
  }, [requiredPermission, navigate]);

  if (requiredPermission && !checkPermission(requiredPermission)) {
    return null; // Don't render component if no permission
  }

  return <Component {...props} />;
};

const AdminRoutesPermission = () => {
  return (
    <React.Fragment>
      <AdminLayout />
      <Routes>
        <Route
          exact
          path="/dashboard"
          element={<PrivateRoute Component={Dashboard} />}
        />

        <Route
          exact
          path="/product-variations"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={ProductVariationsList} requiredPermission="view-product-variations" {...props} />} />}
        />
        <Route
          exact
          path="/add-product-variations"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={AddProductVariations} requiredPermission="create-product-variation" {...props} />} />}
        />
        <Route
          exact
          path="/edit-product-variations"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={EditProductVariations} requiredPermission="edit-product-variation" {...props} />} />}
        />

        <Route
          exact
          path="/product-listing"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={ProductsList} requiredPermission="view-products" {...props} />} />}
        />
        <Route
          exact
          path="/add-product"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={AddProduct} requiredPermission="create-product" {...props} />} />}
        />
        <Route
          exact
          path="/edit-product"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={EditProduct} requiredPermission="edit-product" {...props} />} />}
        />
        <Route
          exact
          path="/product-detail"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={ProductDetail} requiredPermission="view-products" {...props} />} />}
        />

        <Route
          exact
          path="/category-listing"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={CategoryList} requiredPermission="view-categories" {...props} />} />}
        />
        <Route
          exact
          path="/add-category"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={AddCategory} requiredPermission="create-category" {...props} />} />}
        />
        <Route
          exact
          path="/edit-category"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={EditCategory} requiredPermission="edit-category" {...props} />} />}
        />

        {/* <Route exact path='/flow-listing' element={<PrivateRoute Component={FlowList} />} />
          <Route exact path='/add-flow' element={<PrivateRoute Component={AddFlow} />} />
          <Route exact path='/edit-flow' element={<PrivateRoute Component={EditFlow} />} /> */}

        <Route
          exact
          path="/admin-user-listing"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={AdminUserListing} requiredPermission="view-admin-users" {...props} />} />}
        />
        <Route
          exact
          path="/add-admin-user"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={AddAdminUser} requiredPermission="create-admin-user" {...props} />} />}
        />
        <Route
          exact
          path="/edit-admin-user"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={EditAdminUser} requiredPermission="edit-admin-user" {...props} />} />}
        />
        {null}

        <Route
          exact
          path="/client-user-listing"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={ClientUserListing} requiredPermission="view-users" {...props} />} />}
        />

        <Route
          exact
          path="/client-user-detail"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={ClientUserDetail} requiredPermission="view-users" {...props} />} />}
        />

        <Route
          exact
          path="/guide-listing"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={GuideList} requiredPermission="view-guide-products" {...props} />} />}
        />
        <Route
          exact
          path="/add-guide"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={AddGuide} requiredPermission="create-guide-product" {...props} />} />}
        />
        <Route
          exact
          path="/edit-guide"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={EditGuide} requiredPermission="edit-guide-product" {...props} />} />}
        />
        <Route
          exact
          path="/guide-detail"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={GuideDetail} requiredPermission="view-guide-products" {...props} />} />}
        />

        <Route
          exact
          path="/welfare-listing"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={WelfareList} requiredPermission="view-welfares" {...props} />} />}
        />
        <Route
          exact
          path="/add-welfare"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={AddWelfare} requiredPermission="create-welfare" {...props} />} />}
        />
        <Route
          exact
          path="/edit-welfare"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={EditWelfare} requiredPermission="edit-welfare" {...props} />} />}
        />
        <Route
          exact
          path="/welfare-detail"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={WelfareDetail} requiredPermission="view-welfares" {...props} />} />}
        />

        <Route
          exact
          path="/emoji"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={EmojiList} requiredPermission="view-emojis" {...props} />} />}
        />
        <Route
          exact
          path="/add-emoji"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={AddEmoji} requiredPermission="create-emoji" {...props} />} />}
        />
        <Route
          exact
          path="/edit-emoji"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={EditEmoji} requiredPermission="edit-emoji" {...props} />} />}
        />

        <Route
          exact
          path="/app-notifications"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={AppNotificationList} requiredPermission="view-app-notifications" {...props} />} />}
        />
        <Route
          exact
          path="/add-app-notification"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={AddAppNotifications} requiredPermission="create-app-notification" {...props} />} />}
        />
        <Route
          exact
          path="/edit-app-notifications"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={EditAppNotifications} requiredPermission="edit-app-notification" {...props} />} />}
        />

        <Route
          exact
          path="/symptom"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={SymptomList} requiredPermission="view-symptoms" {...props} />} />}
        />
        <Route
          exact
          path="/add-symptom"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={AddSymptom} requiredPermission="create-symptom" {...props} />} />}
        />
        <Route
          exact
          path="/edit-symptom"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={EditSymptom} requiredPermission="edit-symptom" {...props} />} />}
        />

        <Route
          exact
          path="/push-notifications"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={FirebaseNotificationList} requiredPermission="view-push-notifications" {...props} />} />}
        />
        <Route
          exact
          path="/add-push-notification"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={AddFirebaseNotifications} requiredPermission="create-push-notification" {...props} />} />}
        />
        <Route
          exact
          path="/edit-push-notifications"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={EditFirebaseNotifications} requiredPermission="edit-push-notification" {...props} />} />}
        />
        {/* <Route exact path='/firebase-notifications' element={<PrivateRoute Component={FirebaseNotificationList} />} />
          <Route exact path='/add-firebase-notification' element={<PrivateRoute Component={AddFirebaseNotifications} />} />
          <Route exact path='/edit-firebase-notifications' element={<PrivateRoute Component={EditFirebaseNotifications} />} /> */}
        {/* Discovers */}
        <Route
          exact
          path="/discover-listing"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={DiscoverListing} requiredPermission="view-discovers" {...props} />} />}
        />
        <Route
          exact
          path="/add-discover"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={AddDiscover} requiredPermission="create-discover" {...props} />} />}
        />
        <Route
          exact
          path="/edit-discover"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={EditDiscover} requiredPermission="edit-discover" {...props} />} />}
        />
        <Route
          exact
          path="/discover-detail"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={DiscoverDetail} requiredPermission="view-discovers" {...props} />} />}
        />

        <Route
          exact
          path="/setting"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={Setting} requiredPermission="settings" {...props} />} />}
        />

        <Route
          exact
          path="/subscription"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={Subscription} requiredPermission="subscriptions" {...props} />} />}
        />

        {/* Role Routes */}
        <Route
          exact
          path="/role-listing"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={RoleList} requiredPermission="view-roles" {...props} />} />}
        />
        <Route
          exact
          path="/add-role"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={(props) => <AddEdit {...props} mode={'create'} />} requiredPermission="create-role" {...props} />} />}
        />
        <Route
          exact
          path="/edit-role"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={(props) => <AddEdit {...props} mode={'edit'} />} requiredPermission="edit-role" {...props} />} />}
        />

        <Route
          exact
          path="*"
          element={<PrivateRoute Component={Dashboard} />}
        />
        <Route
          exact
          path="/role-detail"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={RoleDetail} requiredPermission="view-roles" {...props} />} />}
        />

        <Route
          exact
          path="/analytics"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={Analytics} requiredPermission="view-analytics" {...props} />} />}
        />

        <Route
          exact
          path="/reports"
          element={<PrivateRoute Component={(props) => <PermissionRoute Component={Reports} requiredPermission="view-reports" {...props} />} />}
        />

        <Route exact path="/logout" element={<Logout />} />

        {/* <Route exact path='/logout' element={<Logout />} /> */}
      </Routes>
    </React.Fragment>
  );
};
export default AdminRoutesPermission;
